import { useCallback } from 'react';
import InlineCitation from 'ai-components-ui-library/components/citation/InlineCitation';
import { CitationsIcon } from '../../components/citations/CitationsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const InlineCitationSectionFormatter = ({
  section,
  callbacks
}) => {
  const {
    id,
    citation
  } = section;
  const handleSourceClick = useCallback(() => {
    var _callbacks$CITATION, _callbacks$CITATION$o;
    window.open(citation.href, '_blank');
    callbacks === null || callbacks === void 0 || (_callbacks$CITATION = callbacks.CITATION) === null || _callbacks$CITATION === void 0 || (_callbacks$CITATION$o = _callbacks$CITATION.onCitationClick) === null || _callbacks$CITATION$o === void 0 || _callbacks$CITATION$o.call(_callbacks$CITATION, {
      id,
      title: citation.title,
      summary: citation.summary,
      href: citation.href,
      sourceName: citation.sourceName,
      iconSrc: citation.iconSrc
    });
  }, [id, citation, callbacks]);
  return /*#__PURE__*/_jsx(InlineCitation, {
    label: citation.label,
    title: citation.title,
    sourceName: citation.sourceName,
    icon: citation.sourceType && /*#__PURE__*/_jsx(CitationsIcon, {
      iconSrc: citation.iconSrc || undefined,
      sourceType: citation.sourceType,
      data: citation.data
    }),
    badges: citation.badges || undefined,
    summary: citation.summary,
    onSourceClick: handleSourceClick
  });
};
export default InlineCitationSectionFormatter;